import { render, staticRenderFns } from "./outOrderList.vue?vue&type=template&id=6189a142&scoped=true"
import script from "./outOrderList.vue?vue&type=script&lang=js"
export * from "./outOrderList.vue?vue&type=script&lang=js"
import style0 from "./outOrderList.vue?vue&type=style&index=0&id=6189a142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6189a142",
  null
  
)

export default component.exports